import i18n from '@/lib/i18n';

export class ConferenceNotFoundError extends Error {
  constructor() {
    super(i18n.t('errors.conferenceNotFound'));
  }
}
